import { CreateTagForm, UpdateTagForm } from 'chaika-frontend-types/frontend-cms';

import { store } from '@store';
import { TagApi } from '@api/TagApi';

class TagService {
    public async load(): Promise<void> {
        const tagList = store.serviceStore.tagList;

        if (tagList.getSize() === 0) {
            const tags = await TagApi.getList();

            tagList.set(tags);
        }
    }

    public async create(params: CreateTagForm): Promise<void> {
        const tagList = store.serviceStore.tagList;

        await TagApi.create(params);

        tagList.add([params]);
    }

    public async update(id: string, params: UpdateTagForm): Promise<void> {
        const tagList = store.serviceStore.tagList;

        await TagApi.update(id, params);

        const current = tagList.getExisting(id);

        tagList.update(id, { ...current, ...params });
    }

    public async remove(id: string): Promise<void> {
        const tagList = store.serviceStore.tagList;

        await TagApi.remove(id);

        tagList.remove(id);
    }
}

export const tagService = new TagService();
